import $ from 'jquery';
import throttle from 'lodash.throttle';

export default class Header {
	constructor(el) {
		this.$el = $(el);
		this.$nav = this.$el.find('.header__nav');
		this.$innerBlock = this.$el.find('.inner-block');
		this.$button = this.$el.find('[data-menu-button]');

		this.$subMenus = this.$el.find('.menu-item-has-children');

		this.subMenus = this.$subMenus.map(
			(i, el) => new SubMenu($(el).parent('.menu-item-wrapper')),
		);

		this.isBurger = false;
		this.isExpanded = true;

		this.recalc();
		$(document).on('load', this.recalc.bind(this));

		$(window).on('resize', throttle(this.recalc.bind(this), 50));

		this.$button.on(
			'click',
			function () {
				this.toggle();
			}.bind(this),
		);
	}

	recalc() {
		// Desired margin between logo and menu
		const navMargin = 200;

		this.availableNavWidth = this.$innerBlock.width() - navMargin;

		const navWidth = this.getNavWidth();

		if (!this.isBurger && navWidth >= this.availableNavWidth) {
			this.$el.addClass('is-burger');
			this.$nav.hide();
			this.isExpanded = false;
			this.isBurger = true;
		} else if (this.isBurger && navWidth < this.availableNavWidth) {
			this.$el.removeClass('is-burger');
			this.$nav.show().css('opacity', 1);
			this.isExpanded = true;
			this.isBurger = false;
		}
	}

	getNavWidth() {
		const isBurger = this.$el.hasClass('is-burger');
		this.$el.removeClass('is-burger');

		const width = this.$nav.width();

		if (isBurger) {
			this.$el.addClass('is-burger');
		}

		return width;
	}

	toggle() {
		if (this.isExpanded) {
			this.collapse();
		} else {
			this.expand();
		}
	}

	expand() {
		this.$nav.velocity('fadeIn', {
			duration: 150,
		});
		this.isExpanded = true;
	}

	collapse() {
		this.$nav.velocity('fadeOut', {
			duration: 150,
		});
		this.isExpanded = false;
	}
}

class SubMenu {
	constructor(el) {
		this.$el = $(el);
		this.$menu = this.$el.find('.sub-menu');

		this.$expandButton = $('<button>').addClass('expand-button');

		this.$expandButton.on('click', (ev) => {
			ev.stopPropagation();
			this.toggle();
		});

		this.$el.children('.menu-item').after(this.$expandButton);

		this.toggle(false);
	}

	toggle(state = null) {
		if (state === null) {
			state = !this.expanded;
		}
		this.$el.toggleClass('is-collapsed', !state);
		this.$expandButton.text(`${state ? 'Dölj' : 'Visa'} undermeny`);
		this.expanded = state;
	}
}
